export const NavItemBadge = () => {
  return (
    <div className="bg-primary-3 absolute right-[-5px] top-[-6px] size-[17px] rounded-full border-4 border-bg-1 group-hover:border-bg-2" />
  )
}
